export default class Utils{

	constructor(){}

	static capitalize(str){

		if (typeof str !== 'string'){
			return '';
		} 
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	static ucwords(str,separator=" "){

		if (typeof str !== 'string'){
			return '';
		} 

		let arr = str.split(separator);

		const words = arr.map((v, i)=>v.charAt(0).toUpperCase() + v.slice(1));

		return words.join(" ");
	}

	static camelCase(str,separator){
		if (typeof str !== 'string'){
			return '';
		} 

		let arr = str.split(separator);

		const words = arr.map((v, i)=>v.charAt(0).toUpperCase() + v.slice(1));
		
		return words.join("");
	}

	static snakeCase(str,separator){
		if (typeof str !== 'string'){
			return '';
		} 

		let re = new RegExp(separator, 'g');

		return str.replace(re,"_").toLowerCase();

	}

	static kebabCase(str,separator){
		if (typeof str !== 'string'){
			return '';
		} 

		let re = new RegExp(separator, 'g');

		return str.replace(re,"-").toLowerCase();
	}

	static formToJson(formElement){
		let inputElements = formElement.querySelectorAll("input,select");
		let jsonObject = {};
        inputElements.forEach(function (input, index) {
			if(input.getAttribute('type') != 'submit'){
            	jsonObject[input.name] = input.value;
			}
        });
		return JSON.stringify(jsonObject);
    }

	static setNotice(noticeContainer,message){
		noticeContainer.innerText = message;
		noticeContainer.style.opacity = 1;
		noticeContainer.style.transform = 'scale(1)';
		setTimeout(function(){
			noticeContainer.style.opacity = 0;
			noticeContainer.style.transform = 'scale(0)';
		},3000);
	}
	
}